import { API_BASE_URL } from '../utils/constants';
import axiosInstance from './axiosInstance';

export const QueryService = {
    getQueries: async (page = 1, limit = 10, status) => {
        try {
            const params = { page, limit };
            if (status) params.status = status;
            const response = await axiosInstance.get(`${API_BASE_URL}/query`, {
                params
            });
            return response.data;
        }
        catch (error) {
            throw error;
        }
    },
    answerQuery: async (id, solution) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/query/${id}/answer`, {
                solution
            });
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
}